import { mode } from "@chakra-ui/theme-tools";
export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: "16px",
        boxShadow: "45px 76px 113px 7px rgba(112, 144, 176, 0.08)",
        transition: ".25s all ease",
        boxSizing: "border-box",
        _focus: {
          boxShadow: "none",
        },
        _active: {
          boxShadow: "none",
        },
      },

      variants: {
        outline: () => ({
          borderRadius: "16px",
        }),
        brand: (props) => ({
          bg: mode("black.900", "black.900")(props),
          color: "white",
          _focus: {
            bg: mode("black.900", "black.900")(props),
          },
          _active: {
            bg: mode("black.900", "black.900")(props),
          },
          _hover: {
            background: "black !important",
          },
        }),
        darkBrand: (props) => ({
          bg: mode("brand.900", "black.900")(props),
          color: "white",
          _focus: {
            bg: mode("brand.900", "black.900")(props),
          },
          _active: {
            bg: mode("brand.900", "black.900")(props),
          },
          _hover: {
            bg: mode("brand.800", "black.900")(props),
          },
        }),
        lightBrand: (props) => ({
          bg: mode("#F2EFFF", "whiteAlpha.100")(props),
          color: mode("black.900", "white")(props),
          _focus: {
            bg: mode("#F2EFFF", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
        }),
        light: (props) => ({
          bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _active: {
            bg: mode("secondaryGray.300", "whiteAlpha.100")(props),
          },
          _hover: {
            bg: mode("secondaryGray.400", "whiteAlpha.200")(props),
          },
        }),
        action: (props) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("secondaryGray.300", "black.900")(props),
          color: mode("black.900", "white")(props),
          _focus: {
            bg: mode("secondaryGray.300", "black.900")(props),
          },
          _active: { bg: mode("secondaryGray.300", "black.900")(props) },
          _hover: {
            bg: mode("secondaryGray.200", "black.900")(props),
          },
        }),
        setup: (props) => ({
          fontWeight: "500",
          borderRadius: "50px",
          bg: mode("transparent", "black.900")(props),
          border: mode("1px solid", "0px solid")(props),
          borderColor: mode("secondaryGray.400", "transparent")(props),
          color: mode("secondaryGray.900", "white")(props),
          _focus: {
            bg: mode("transparent", "black.900")(props),
          },
          _active: { bg: mode("transparent", "black.900")(props) },
          _hover: {
            bg: mode("black.900", "black.900")(props),
          },
        }),
      },
    },
  },
};
